module.exports = __webpack_public_path__ + "static/media/homepage_product_scroll.d346ad20.jpg";